<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="855"
    title="安装应用到设备"
    alignCenter
    @close="handleClose"
  >
    <div class="install-app-container">
      <!-- 选择范围 -->
      <div class="select-scope">
        <span>安装设备范围：</span>
        <el-radio-group
          v-model="selectScopeType"
          @change="handleScopeTypeChange"
        >
          <el-radio :label="'package'">按套餐范围</el-radio>
          <el-radio :label="'spec'">按规格范围</el-radio>
          <el-radio :label="'device'">按指定设备</el-radio>
        </el-radio-group>
      </div>

      <!-- 套餐范围选择 -->
      <div v-if="selectScopeType === 'package'" class="scope-content">
        <el-form :model="packageForm" label-width="140px">
          <el-form-item label="选择套餐">
            <el-select
              v-model="packageForm.packageIds"
              placeholder="请选择套餐"
              style="width: 100%"
              multiple
              clearable
              filterable
              @change="handlePackageChange"
            >
              <el-option
                v-for="item in packageList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
            <el-form-item label="是否安装已售出设备">
              <el-radio-group v-model="packageForm.isInstallSoldDevice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
        </el-form>
        <!-- 已选设备数量显示 -->
        <div class="selected-info" v-if="selectedDeviceCount > 0">
          <el-tag>已选择 {{ selectedDeviceCount }} 台设备</el-tag>
        </div>
      </div>

      <!-- 规格范围选择 -->
      <div v-else-if="selectScopeType === 'spec'" class="scope-content">
        <el-form :model="specForm" label-width="140px">
          <el-form-item label="选择规格">
            <el-select
              v-model="specForm.specIds"
              placeholder="请选择规格"
              style="width: 100%"
              clearable
              filterable
              multiple
              @change="handleSpecChange"
            >
              <el-option
                v-for="spec in specList"
                :key="spec.id"
                :label="spec.nickName"
                :value="spec.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否安装已售出设备">
              <el-radio-group v-model="specForm.isInstallSoldDevice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
        </el-form>
        <!-- 已选设备数量显示 -->
        <div class="selected-info" v-if="selectedDeviceCount > 0">
          <el-tag>已选择 {{ selectedDeviceCount }} 台设备</el-tag>
        </div>
      </div>

      <!-- 指定设备选择 -->
      <div v-else-if="selectScopeType === 'device'" class="scope-content">
        <el-form>
           <el-form-item label="是否安装已售出设备">
              <el-radio-group v-model="isInstallTargetSoldDevice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
        </el-form>
        <el-form :model="deviceFilterForm"  size="small" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="云机物理编号">
                <el-input
                  size="small"
                  v-model="deviceFilterForm.cloudMachineNumber"
                  placeholder="请输入云机物理编号，支持多个,例如a,b"
                  style="width: 100%"
                  clearable
                  @keyup.enter="queryDevices"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="物理机IP">
                <el-input
                  v-model="deviceFilterForm.physicalMachineIp"
                  placeholder="请输入物理机IP，支持多个，例如a,b"
                  style="width: 100%"
                  size="small"
                  clearable
                  @keyup.enter="queryDevices"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-select
                  v-model="deviceFilterForm.status"
                  placeholder="请选择状态"
                  style="width: 100%"
                  size="small"
                  clearable
                  filterable
                  @change="queryDevices"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                <el-button type="primary" size="small" @click="queryDevices"
                  >查询</el-button
                >
                <el-button size="small" @click="resetDeviceFilter">重置</el-button>
          </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 设备列表 -->
        <div class="device-list">
          <!-- 替换为comTable组件 -->
          <comTable
            v-loading="deviceListLoading"
            :tableItem="deviceTableItem"
            :tableData="deviceList"
            style="width: 100%;min-height:200px;max-height: 284px;"
            :hideCheckBox="false"
            @update:multipleSelection="handleSelectionChange"
          ></comTable>
          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              v-model:current-page="devicePagination.currentPage"
              v-model:page-size="devicePagination.pageSize"
              :page-sizes="[50, 100, 200, 500, 1000]"
              size="small"
              layout="total, sizes, prev, pager, next, jumper"
              :total="devicePagination.total"
              @size-change="handleDevicePageSizeChange"
              @current-change="handleDeviceCurrentPageChange"
            />
          </div>
        </div>
      </div>

      <!-- 应用选择 -->
      <div class="app-selection">
        <el-form  label-width="100px">
          <el-form-item label="已选择应用:">
            <div style="margin-top: 4px;">
               <el-tag v-for="app in appList" :key="app.id" style="margin: 0 8px 8px 0;">{{ app.appName }}</el-tag>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 底部按钮 -->
      <div class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="installLoading" :disabled="installLoading" @click="handleInstall">安装</el-button>
      </div>
  </ComDialog>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from "vue";
import { ElMessage } from "element-plus";
import ComDialog from "@/components/comDialog/index.vue";
// 导入comTable组件
import comTable from "@/components/comTable/index.vue";
import API_CONFIG from "../api.json";
import request from "@/utils/request";
import debounce from "lodash-es/debounce.js";

const statusList = ref([
  { label: "空闲", value: "0" },
  { label: "回收中", value: "1" },
  { label: "清退", value: "2" },
  { label: "售出", value: "3" },
  { label: "异常设备", value: "4" },
]);
// Emits
const emit = defineEmits(["close", "installSuccess"]);
const installLoading = ref(false);
// 响应式数据
const dialogVisible = ref(false);
const selectScopeType = ref("package"); // 'package': 套餐范围, 'spec': 规格范围, 'device': 指定设备

// 套餐范围表单
const packageForm = reactive({
  packageIds: [],
  isInstallSoldDevice: 0
});

// 规格范围表单
const specForm = reactive({
  specIds: [],
  isInstallSoldDevice: 0
});

// 设备筛选表单
const deviceFilterForm = reactive({
  cloudMachineNumber: "",
  physicalMachineIp: "",
  status: ""
});
const isInstallTargetSoldDevice = ref(0);

// 数据列表
const packageList = ref([]);
const specList = ref([]);
let appList = ref([]);
const deviceList = ref([]);
const deviceListLoading = ref(false);

// 分页信息
const devicePagination = reactive({
  currentPage: 1,
  pageSize: 100,
  total: 0,
});

// 选中的设备和应用
const selectedDevices = ref([]);

// 已选设备数量
const selectedDeviceCount = computed(() => {
  if (selectScopeType.value === "device") {
    return selectedDevices.value.length;
  } else if (selectScopeType.value === "package") {
    // 这里应该根据套餐计算设备数量，暂时返回0
    return 0;
  } else if (selectScopeType.value === "spec") {
    // 这里应该根据规格计算设备数量，暂时返回0
    return 0;
  }
  return 0;
});

// 设备表格列配置
const deviceTableItem = ref([
  { label: "云机物理编号", prop: "cloudMachineNumber", width:200 },
  { label: "物理机IP", prop: "physicalMachineIp" },
  { label: "云机开数", prop: "cloudMachinesOpenNum" },
  { label: "镜像版本", prop: "mirrorVersion" },
  { label: "机房", prop: "machineRoom" },
  {
    label: "状态",
    prop: "status",
    valueFormatter: ({ value }) => {
      const status = statusList.value.find(item => item.value === value);
      return status ? status.label : value;
    },
    cellStyle: ({ value }) => {
      const statusMap = {
        "0": "success",
        "1": "danger",
        "2": "warning",
        "3": "info",
        "4": "default"
      };
      
      const type = statusMap[value] || "default";
      const colorMap = {
        success: "#67c23a",
        danger: "#f56c6c",
        warning: "#e6a23c",
        info: "#909399",
        default: "#909399"
      };
      return {
        color: colorMap[type]
      };
    }
  }
]);


// 生命周期
onMounted(() => {
  initData();
});

const initData = async () => {
  await getPackageList();
  await getSpecList();
};

// 获取套餐列表
const getPackageList = async () => {
  try {
    const res = await request.post(API_CONFIG.querySpu.url);
    if (res.code === 200) {
      packageList.value = res.data || [];
    }
  } catch (error) {
    console.error("获取套餐列表失败:", error);
  }
};

// 获取规格列表
const getSpecList = async () => {
  try {
    const res = await request.post(API_CONFIG.queryCategory.url);
    if (res.code === 200) {
      specList.value = res.data || [];
    }
  } catch (error) {
    console.error("获取规格列表失败:", error);
  }
};

// 查询设备列表
const queryDevices = async () => {
  deviceListLoading.value = true;
  try {
    const params = {
      ...deviceFilterForm,
      pageDomain:{
        pageSize: devicePagination.pageSize,
        pageNum: devicePagination.currentPage,
      }
    };
    if(params.status===''){
      delete params.status;
    }
    const res = await request.post(API_CONFIG.queryDevice.url, params);
    if (res.code === 200) {
      deviceList.value = res.data.data || [];
      devicePagination.total = res.data.total || 0;
    }
  } catch (error) {
    ElMessage.error("查询设备列表失败");
  } finally {
    deviceListLoading.value = false;
  }
};

// 重置设备筛选条件
const resetDeviceFilter = () => {
  Object.keys(deviceFilterForm).forEach((key) => {
    deviceFilterForm[key] = "";
  });
  devicePagination.currentPage = 1;
  queryDevices();
};

// 处理范围类型切换
const handleScopeTypeChange = (val) => {
  // 清空之前的选择
  packageForm.packageIds = [];
  specForm.specIds = [];
  selectedDevices.value = [];
  if(val === 'device'){
    queryDevices();
  }
};

// 处理套餐选择变化
const handlePackageChange = () => {
  specForm.specIds = [];
  specForm.isInstallSoldDevice = 0;
  selectedDevices.value = [];
};

// 处理规格选择变化
const handleSpecChange = () => {
  packageForm.packageIds = [];
  packageForm.isInstallSoldDevice = 0;
  selectedDevices.value = [];
};

// 处理设备分页大小变化
const handleDevicePageSizeChange = (size) => {
  devicePagination.pageSize = size;
  queryDevices();
};

// 处理设备当前页变化
const handleDeviceCurrentPageChange = (current) => {
  devicePagination.currentPage = current;
  queryDevices();
};

// 处理选择变化
const handleSelectionChange = (selectedRows) => {
  // 保存选中的设备ID
  selectedDevices.value = selectedRows
};

// 检查表单是否有效
const validateForm = () => {
  if (
    selectScopeType.value === "package" &&
    packageForm.packageIds.length === 0
  ) {
    ElMessage.warning("请选择套餐");
    return false;
  }

  if (selectScopeType.value === "spec" && specForm.specIds.length === 0) {
    ElMessage.warning("请选择规格");
    return false;
  }

  if (
    selectScopeType.value === "device" &&
    selectedDevices.value.length === 0
  ) {
    ElMessage.warning("请选择要安装的设备");
    return false;
  }

  return true;
};

// 处理安装
const handleInstall =  debounce( async() => {
  if (!validateForm()) {
    return;
  }

  try {
    let params = {
      appList: appList.value,
      isInstall: true,
      targetPath: "",
    };

    // 根据选择的范围类型构建不同的参数
    if (selectScopeType.value === "package") {// 套餐
      params = {
        ...params,
        installScopeType: "BY_PACKAGE",
        isInstallSoldDevice: packageForm.isInstallSoldDevice==1?true:false,
        spuIdList: packageForm.packageIds,
      };
    } else if (selectScopeType.value === "spec") { // 规格
      params = {
        ...params,
        installScopeType: "BY_CATEGORY",
        isInstallSoldDevice: specForm.isInstallSoldDevice==1?true:false,
        categoryIdList: specForm.specIds,
      };
    } else if (selectScopeType.value === "device") { //自定义设备
      params = {
        ...params,
        installScopeType: "BY_DEVICE",
        deviceCodeList: selectedDevices.value.map(item => item.cloudMachineNumber),
        isInstallSoldDevice: isInstallTargetSoldDevice.value==1?true:false,
      };
    }
    installLoading.value = true;
    const res = await request.post(API_CONFIG.installAppToDevice.url, params);
    if (res.code === 200) {
      ElMessage.success("应用安装任务已提交");
      emit("installSuccess", res.data);
      handleClose();
    } else {
      ElMessage.error(res.msg || "应用安装失败");
    }
  } catch (error) {
    console.error(error)
  } finally {
    installLoading.value = false;
  }
},300);

// 处理关闭
const handleClose = () => {
  // 重置表单
  resetForm();
  emit("close");
  dialogVisible.value = false;
};

// 重置表单
const resetForm = () => {
  selectScopeType.value = "package";
  packageForm.packageIds = [];
  packageForm.isInstallSoldDevice = 0;
  specForm.specIds = [];
  specForm.isInstallSoldDevice = 0;
  selectedDevices.value = [];
  resetDeviceFilter();
};

// 打开弹窗
const open = (data) => {
  appList.value = data || [];
  dialogVisible.value = true;
};

// 暴露方法给父组件
defineExpose({
  open
});
</script>

<style scoped>
.install-app-container {
  padding: 20px;
  user-select: none;
}

.select-scope {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
}

.scope-content {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.selected-info {
  margin-top: 10px;
}

.app-selection {
  margin-bottom: 20px;
}

.app-info {
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.info-item {
  margin-bottom: 5px;
}

.info-item .label {
  font-weight: 500;
  margin-right: 5px;
}

.device-list {
  margin-top: 15px;
}

.pagination {
  margin-top: 15px;
  text-align: right;
}

.dialog-footer {
    background-color: #ffffff;
    z-index: 10;
    display: flex;
    justify-content: center;
    position: absolute;
    padding: 20px 0;
    bottom: 0;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
}
</style>